import { IOption } from '@/interfaces/option/option.interface'

export function sortObjectByValue(a: IOption, b: IOption) {
  if (a.value < b.value) return -1
  if (a.value > b.value) return 1
  return 0
}
